<template>
  <div
    class="tw-flex tw-items-center tw-justify-center tw-px-[10px] tw-py-[2px] md:tw-px-[12px] md:tw-py-[4px] tw-rounded-full tw-text-center tw-text-[10px] md:tw-text-[13px] tw-font-bold"
    :style="{ backgroundColor: statuses?.[status]?.bgColor, color: statuses?.[status]?.color }"
  >
    {{ this.$t(statuses?.[status]?.nameKey, statuses?.[status]?.nameDefault) }}
  </div>
</template>

<script>
import { statuses } from "@/views/donor-dashboard/my-contacts/constants";

export default {
  data() {
    return {
      statuses,
    };
  },

  props: {
    status: {
      type: String,
      required: true,
    },
  },

  name: "my-status-badge",
};
</script>
